import { Dictionary, TIconNameColorMap } from "../types/utils.types";

export const PARTICIPANT_TYPE = {
  INTERVIEWER: "INTERVIEWER",
  CANDIDATE: "CANDIDATE",
};

export const ICON_NAME_COLOR_MAP: Dictionary<TIconNameColorMap> = {
  error: {
    name: "errorOutline",
    color: "#E51635",
  },
  info: {
    name: "info",
    color: "#2F2B82",
  },
  warning: {
    name: "warning",
    color: "#984F11",
  },
  success: {
    name: "checkCircle",
    color: "#1A5C2C",
  },
};

export const HIDE_TOAST_DEFAULT_TIME_IN_SECONDS = 2;

export const LOCAL_VIDEO_CONSTRAINTS: MediaTrackConstraints = {
  width: 290,
  height: 166,
};
export const SEND_ELEMENTS_AND_FILES_TIME_IN_SECONDS = 10 * 1000;

export const DEFAULT_AUTOCOMPLETE_SEARCH_SIZE = 8;

export const MOVE_CANDIDATE_TO_LOBBY_IN_SECONDS = 5;

export const MOVE_TO_FEEDBACK_ON_INTERVIEW_END_IN_SECONDS = 4;

export const CANDIDATE_ACTIVE_SLUG = "candidateActiveSlug";

export const ZOOM_PARTICIPANT_VIDEO_WIDTH = 250;

export const ZOOM_PARTICIPANT_VIDEO_HEIGHT = 166;

export const ZOOM_PARTICIPANT_WINDOW_HEIGHT = 178;

export const ZOOM_PARTICIPANT_VIDEO_CODRINATE_X = 0;

export const ZOOM_SESSION_TIMEOUT = 2.5 * 60 * 1000;
